<script>
import FufuHeader from '@/components/FufuHeader'
import { api } from '@/api'

function fetchData(shopId) {
  return Promise.all([api.shops(shopId).get()])
}

export default {
  name: 'CampaignPage',
  components: {
    FufuHeader,
  },
  props: {
    shopId: {
      type: String,
      required: true,
    },
    mode: {
      type: Number,
      default: 1,
    },
  },
  data: () => ({
    shop: null,
  }),
  methods: {
    goNext() {
      this.$router.replace({
        name: 'MenuSelection',
        params: {
          shopId: this.shopId,
        },
        query: {
          first: true,
          mode: this.mode,
        },
      })
    },
  },

  async beforeRouteEnter(to, from, next) {
    let shopId = to.params.shopId
    try {
      const [shop] = await fetchData(shopId)
      next(vm => {
        vm.shop = shop
      })
    } catch (err) {
      next(err)
    }
  },
  async beforeRouteUpdate(to, from, next) {
    let shopId = to.params.shopId
    try {
      const [shop] = await fetchData(shopId)
      next(vm => {
        vm.shop = shop
      })
    } catch (err) {
      next(err)
    }
  },
}
</script>

<template>
  <div class="fill-height">
    <FufuHeader :shop="shop"> 初回予約 </FufuHeader>
    <v-container class="white" fill-height>
      <v-layout column>
        <v-layout>
          <v-flex xs4>
            <v-btn to="/first" text exact color="primary" replace>
              <v-icon>mdi-chevron-right</v-icon>
              前の画面へ戻る
            </v-btn>
          </v-flex>
          <v-flex xs4 class="text-center">
            初回のお客様限定キャンペーン
          </v-flex>
        </v-layout>

        <v-img :src="`${$publicPath}img/campaign.jpg`" contain />

        <p class="body-1">
          ※どちらのメニューも、シャンプー・トリートメント込の料金になります。
          <br />
          ※頭頂から35cmまでをショート、35～45cmをミディアム（+550円税込）、45 ～
          60cmをロング（+1,100円税込）、それ以上をスーパーロング（+1,650円税込）とさせていただいております。
        </p>

        <v-card outlined tile>
          <v-toolbar flat color="bgColor">
            <v-layout justify-center>
              <v-toolbar-title class="fufugrey2--text">
                注意事項
              </v-toolbar-title>
            </v-layout>
          </v-toolbar>
          <v-card-text class="text-h6 fufugrey2--text">
            <p>
              ※ブリーチ、ハイライト、メッシュ、グラデーション、ダブルカラー、ツートンカラー、ヘナ、ヘアマニキュアの取り扱いはございません。
            </p>
            <p>
              ※ハイライト・マニキュア・ブリーチ・ヘナカラー・昆布成分を利用したカラートリートメント等をされている場合、ブリーチで髪の傷みが激しい場合など、髪の状態によっては施術が出来ない場合もございます。ご了承下さい。
            </p>
          </v-card-text>
        </v-card>

        <v-layout>
          <v-flex xs4 offset-xs4 class="pt-5">
            <v-btn
              color="fufuyellow"
              text-color="fufugrey2"
              x-large
              block
              @click="goNext"
            >
              <span class="subtitle-1">
                <b>了承した</b>
              </span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-layout>
    </v-container>
  </div>
</template>
